/* tslint:disable */

declare var Object: any;
export interface TtadondutyrequestdtlItemInterface {
  "requestNo": string;
  "companyId": number;
  "destinationNo": number;
  "ondutyDate": Date;
  "standardValue": string;
  "allowanceValue": string;
  "remark"?: string;
  "itemCode": string;
  "currencyCode"?: string;
  "type"?: string;
  rel_allowance?: any;
}

export class TtadondutyrequestdtlItem implements TtadondutyrequestdtlItemInterface {
  "requestNo": string;
  "companyId": number;
  "destinationNo": number;
  "ondutyDate": Date;
  "standardValue": string;
  "allowanceValue": string;
  "remark": string;
  "itemCode": string;
  "currencyCode": string;
  "type": string;
  rel_allowance: any;
  constructor(data?: TtadondutyrequestdtlItemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TtadondutyrequestdtlItem`.
   */
  public static getModelName() {
    return "TtadondutyrequestdtlItem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TtadondutyrequestdtlItem for dynamic purposes.
  **/
  public static factory(data: TtadondutyrequestdtlItemInterface): TtadondutyrequestdtlItem{
    return new TtadondutyrequestdtlItem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TtadondutyrequestdtlItem',
      plural: 'TtadondutyrequestdtlItems',
      path: 'TtadondutyrequestdtlItems',
      properties: {
        "requestNo": {
          name: 'requestNo',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "destinationNo": {
          name: 'destinationNo',
          type: 'number'
        },
        "ondutyDate": {
          name: 'ondutyDate',
          type: 'Date'
        },
        "standardValue": {
          name: 'standardValue',
          type: 'string'
        },
        "allowanceValue": {
          name: 'allowanceValue',
          type: 'string'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "itemCode": {
          name: 'itemCode',
          type: 'string'
        },
        "currencyCode": {
          name: 'currencyCode',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
      },
      relations: {
        rel_allowance: {
          name: 'rel_allowance',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/TtadondutyrequestdtlItem.ts